import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TrendComponent } from './trend.component';

@NgModule({
  imports: [CommonModule],
  exports: [TrendComponent],
  declarations: [TrendComponent],
})
export class TrendModule {
}
